import { Warning as WarningIcon } from "@mui/icons-material";
import { Box, ButtonBase, Typography } from "@mui/material";

interface StrandLossWarningRowProps {
  strandNumber: number;
  heatName: string | null;
  onClick: () => void;
}

const getLabel = (strandNumber: number, heatName: string | null) =>
  heatName === null
    ? `Strand ${strandNumber} Loss:`
    : `Strand ${strandNumber} (${heatName}) Loss:`;

export const StrandLossWarningRow = ({
  strandNumber,
  heatName,
  onClick,
}: StrandLossWarningRowProps) => (
  <ButtonBase
    onClick={onClick}
    sx={(theme) => ({
      alignItems: "center",
      borderRadius: 0.5,
      display: "flex",
      gap: 0.5,
      justifyContent: "flex-start",
      minWidth: 0,
      px: 0.5,
      "&:hover": { backgroundColor: theme.palette.action.hover },
      "&.Mui-focusVisible": {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 1,
      },
    })}
  >
    <WarningIcon
      color="warning"
      sx={{ fontSize: 14, flexShrink: 0 }}
      aria-hidden
    />
    <Typography
      component="span"
      variant="caption"
      sx={{
        color: "warning.main",
        fontWeight: 600,
        lineHeight: 1.3,
        textAlign: "left",
      }}
    >
      <Box component="span" sx={{ color: "text.primary" }}>
        {getLabel(strandNumber, heatName)}
      </Box>
      {" reason required"}
    </Typography>
  </ButtonBase>
);
